import React from 'react';

import { Headline, Text, Box } from '@freenow/wave';
import { BusinessAccountSelector } from './BusinessAccountSelector';
import { BusinessAccount } from '../api/central-organisations.api';

interface Props {
    title: string;
    subtitle?: string;
    children?: React.ReactNode;
    rightBoxId?: string;
    showBusinessAccountSelector?: boolean;
    businessAccountSelectorFilter?: (businessAccount: BusinessAccount) => boolean;
}

export const PageHeader = ({
    title,
    children,
    subtitle = '',
    rightBoxId,
    showBusinessAccountSelector,
    businessAccountSelectorFilter,
}: Props) => (
    <Box display="flex" justifyContent="space-between" mb={3} data-testid="page-header">
        <Box display="flex" flexDirection="column">
            <Box display="flex" alignItems="center">
                <Headline as="h2" mr={showBusinessAccountSelector ? 4 : 0}>
                    {title}
                </Headline>
                {showBusinessAccountSelector ? (
                    <BusinessAccountSelector filter={businessAccountSelectorFilter} />
                ) : null}
            </Box>
            {subtitle ? (
                <Text as="p" fontSize={1} mt={1}>
                    {subtitle}
                </Text>
            ) : null}
        </Box>
        {children ? (
            <Box ml={2} minWidth="200px" flexShrink={0} display="flex" justifyContent="flex-end" id={rightBoxId}>
                {children}
            </Box>
        ) : null}
    </Box>
);
